<template>
	<div class="in-out-statistic">
		<lcsj-filter more-text="更多筛选" @search="loadData()">
			<el-form-item label="年份：">
				<el-date-picker
					v-model="inputYear"
					type="year"
					:clearable="false"
					value-format="yyyy"
					placeholder="选择年"
					:editable="false"
					format="yyyy年"
					size="small"
					@change="changeYear"
				></el-date-picker>
			</el-form-item>
			<el-form-item>
				<span class="tip">按上线商品类型(镜片类型)统计 1~12 月实际出入库数量（入库时间 / 出库时间）</span>
			</el-form-item>
			</lcsj-filter>
		<div ref="tableWrap" class="table-wrap">
			<el-table
				v-loading="loading"
				:data="tableData"
				border
				size="small"
				:height="tableHeight"
				
			>
			<el-table-column type="index" label="序号" width="60" align="center" fixed="left">
				<template slot-scope="scope">
					<span v-if="scope.row.goodsTypeName === '合计'"></span>
					<span v-else>{{ scope.$index + 1 }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="goodsTypeName" label="镜片类型（上线商品类型）" min-width="240" align="center" fixed="left"></el-table-column>
			<el-table-column v-for="m in 12" :key="'m' + m" :label="m + '月'" align="center">
				<el-table-column :key="'i' + m" label="入库" width="100" align="center">
					<template slot-scope="scope">{{ fmtCount(scope.row.inputCounts[m - 1]) }}</template>
				</el-table-column>
				<el-table-column :key="'o' + m" label="出库" width="100" align="center">
					<template slot-scope="scope">{{ fmtCount(scope.row.outputCounts[m - 1]) }}</template>
				</el-table-column>
			</el-table-column>
			<el-table-column label="全年合计" align="center">
				<el-table-column label="入库" width="100" align="center">
					<template slot-scope="scope">{{ fmtCount(scope.row.totalInputCount) }}</template>
				</el-table-column>
				<el-table-column label="出库" width="100" align="center">
					<template slot-scope="scope">{{ fmtCount(scope.row.totalOutputCount) }}</template>
				</el-table-column>
			</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import { GetInOutStatistics } from "@/api/receiptApi.js";
export default {
	data() {
		return {
			loading: false,
			inputYear: new Date().getFullYear().toString(),
			formInline: {
				year: new Date().getFullYear()
			},
			tableData: [],
			tableHeight: 400
		};
	},
	created() {
		this.loadData();
	},
	mounted() {
		this.calcTableHeight();
		window.addEventListener("resize", this.calcTableHeight);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.calcTableHeight);
	},
	methods: {
		// 表格高度取容器实际剩余空间再留少量余量，避免合计行贴边被裁切
		calcTableHeight() {
			this.$nextTick(() => {
				const wrap = this.$refs.tableWrap;
				if (wrap && wrap.clientHeight > 0) {
					this.tableHeight = Math.max(wrap.clientHeight - 40, 200);
				}
			});
		},
		// 数量为 0 显示 --
		fmtCount(val) {
			return Number(val) || 0 ? val : "--";
		},
		loadData() {
			this.loading = true;
			GetInOutStatistics(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.tableData = res.data && res.data.dtls ? res.data.dtls : [];
					} else {
						this.$message({ type: "info", message: res.msg });
						this.tableData = [];
					}
				})
				.catch(() => {
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		changeYear(val) {
			if (val) {
				this.formInline.year = parseInt(val);
			}
			this.loadData();
		}
	}
};
</script>

<style scoped lang="scss">
.in-out-statistic {
	flex: 1;
	min-height: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
}
.user-search {
	margin-bottom: 10px;
	flex-shrink: 0;
	.tip {
		color: var(--app-text-muted);
		font-size: 12px;
	}
}
.table-wrap {
	flex: 1;
	min-height: 0;
	overflow: hidden;
}
</style>
